import { create } from "zustand";

type State = {
  tutorialMode: boolean;
};

type Actions = {
  toggleTutorialMode: () => void;
};

export const useClientTutorialStore = create<State & Actions>()((set) => ({
  tutorialMode: false,
  toggleTutorialMode: () => set((state) => ({ tutorialMode: !state.tutorialMode })),
}));
